var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_57_2670",
    transform: "scale(0.0208333)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_57_2670",
    width: 48,
    height: 48,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAACA0lEQVRoge2Zu0oDQRSGI4oKitgFccllkyq1UfC2L+GbWIm+gBZWAZ9AorVJpfgUGm8giKZUxMZCUf8DGzksJDuXzMwG5oefNDvnfP/sbTKby3l5eXllXuVyeQM+gbvwN/xryFT7BW6GYbimDR5F0QSKHRkEHuhSqdQgBp2ZdwbPQyjBY+BmotAZfuu1Wm1SeUZSRLWpB3q1eG+lywkDTzm8Ad6BQs82638sXSC+YXszsGSAcaAAvcICPEsX4E8bk5dNPxWLxWkW4Eu6AL8GDfCJaIwx/EiPdv30SdgHcG29ANKDh6Ph3QMG4ETkA/gAmhr5AMSwVSgUFvL5/IzKYOcBtOQ6ANZC81gDHcJPtBaC78CyK7wucxmgWq0G6Hvb56V2KRTCVQCCx2w/pLyZd1ILuQggCE++SS1mO4AEPPkztaDNAJLw5MfMBFCAJ+9nIoAifAfj5pwHUIHH8fdBECwKNTAZwDi8yQBW4OMA/9sqaDo1UvBxgC4rVNeFJwhr8HGAJivU0oHH2mUWda6twZPCMFxPFGzTdp/K5USrSqvwrHFD8hnNId5RYjzecX6zDk+ijwuqIXo72skzaQ2eq1KprNIWN+0S058LQaBtGovj95zC6wpgFyMLTwLcRwr8VWbhSYDs9IF/hQ+UdhxsCpDLNMt0JuBzuifoxnbx0cTLhP4Ahz1JbcCva24AAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditorIcon);
export default __webpack_public_path__ + "static/media/editorIcon.038b35a75a49b52a8158908851bf828c.svg";
export { ForwardRef as ReactComponent };